import React, { useState } from "react";
import Nav from "../../NavBar/Nav";
import Savings from "../../../../Assets/Savings.png";
import pngwing1 from "../../../../Assets/pngwing1.png";
import pngwing2 from "../../../../Assets/pngwing2.png";
import Products from "../../NavBar/Products";
import Company from "../../NavBar/Company";
import Support from "../../NavBar/Support";

const Headers2 = () => {
  const [modal, setModal] = useState(false);
  const [openModals, setOpenModals] = useState(false);
  const [supportModal, setSupportModal] = useState(false);

  const openModal = () => {
    setModal(true);
  };

  const handleModal = () => {
    setOpenModals(true);
  };

  const handleSupportModal = () => {
    setSupportModal(true);
  };

  return (
    <>
      <Nav
        onClick={openModal}
        onOpen={handleModal}
        onSet={handleSupportModal}
      />
      {modal && <Products onHideModal={() => setModal(false)} />}
      {openModals && <Company onHideModals={() => setOpenModals(false)} />}
      {supportModal && (
        <Support onHideSupportModal={() => setSupportModal(false)} />
      )}

      <header className=" background lg:h-[60.06rem] xl:h-[63.06rem] md:h-[39.06rem] h-[58.06rem]">
        <div
          className="mac:max-w-[83rem] pro:max-w-[52rem] max-w-[21.5rem] xl:max-w-[75rem] md:max-w-[45rem]
            lg:max-w-[60rem] mx-auto flex flex-col-reverse sm:flex-row sm:justify-between pt-[9.5rem]"
        >
          <div className="lg:pt-[11.75rem] md:pt-[8.75rem] pt-[3.75rem]">
            <h1 className="text-[#1D1D1F] text-[1.375rem] md:text-[1.5rem] pb-[1rem] lg:text-[1.8rem] xl:text-[2.475rem] mac:text-[2.875rem] font-bold tracking-[-0.0575rem]">
              Financial wellness starts
              <br />
              with <span className="text-[#017A59]">Savings</span>. Transform{" "}
              <br />
              your future today
            </h1>

            <p className="text-[#8A9099] text-[1.125rem] md:text-sm lg:text-sm xl:text-[1.175rem] mac:text-[1.375rem] leading-normal lg:leading-[2.125rem] font-medium">
              All seasons are not the same. Save now and start{" "}
              <br className="hidden lg:block" />
              enjoying financial independence.
            </p>
            <div className="flex md:pt-[1.5rem] lg:pt-[6rem] gap-[2rem] pt-[1.76rem]">
              <img
                src={pngwing1}
                alt="get on PlayStore"
                className="object-contain md:w-[7.375rem] w-[6.375rem] lg:w-[10.375rem] xl:w-[14.375rem] h-[5.375rem]"
              />
              <img
                src={pngwing2}
                alt="get on ios"
                className="lg:w-[10.375rem] md:w-[7.375rem] w-[6.3125rem] xl:w-[14.3125rem] object-contain h-[4.25rem] mt-[0.56rem]"
              />
            </div>
          </div>
          <div className="lg:pt-[5.05rem] md:pt-[2.505rem] pt-[2.5rem]">
            <img
              src={Savings}
              alt=""
              className="xl:h-[41.6875rem] lg:h-[35.6875rem] lg:w-[39.5625rem] xl:w-[44.5625rem]"
            />
          </div>
        </div>
      </header>
    </>
  );
};

export default Headers2;
